export default __webpack_public_path__ + "static/media/b26.05eac401.png";